<template>
    <div class="login-page">
        <div class="background-grid"></div>
        <div class="background-glow glow-1"></div>
        <div class="background-glow glow-2"></div>

        <div class="login-shell">
            <!-- <section class="brand-panel">
                <div class="brand-top">
                    <img
                        src="@/assets/fundo_conduril.png"
                        alt="Conduril"
                        class="brand-logo"
                    />
                    <span class="brand-badge">Acesso Interno</span>
                </div>

                <div class="brand-content">
                    <p class="eyebrow">Plataforma central</p>
                    <h1>Autenticação única para todas as aplicações internas</h1>
                    <p class="brand-text">
                        Uma experiência de acesso segura, simples e consistente para os
                        colaboradores Conduril.
                    </p>

                    <div class="brand-points">
                        <div class="point">
                            <span class="point-icon">✓</span>
                            <span>Single Sign-On</span>
                        </div>
                        <div class="point">
                            <span class="point-icon">✓</span>
                            <span>Integração com conta Microsoft</span>
                        </div>
                        <div class="point">
                            <span class="point-icon">✓</span>
                            <span>Entrada centralizada e experiência uniforme</span>
                        </div>
                    </div>
                </div>

                <div class="brand-footer">
                    <span>Conduril - Engenharia</span>
                </div>
            </section> -->

            <section class="login-panel">
                <div elevation="12" class="card">
                    <div class="card-header">
                        <!-- <div class="logo-mini">C</div> -->
                         <img
                            src="@/assets/fundo_conduril.png"
                            alt="Conduril"
                            class="brand-logo mx-auto mb-12"
                        />
                        <h2>{{ title }}</h2>
                        <p>{{ description }}</p>
                    </div>

                    <div class="actions">
                        <slot name="actions"></slot>
                    </div>

                    <div class="divider">
                        <span>{{ dividerText }}</span>
                    </div>

                    <div class="card-footer">
                        <slot name="footer">
                            <p>{{ footerText }}</p>
                        </slot>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import "@/styles/login-page.css";

export default {
    name: "AuthShell",

    props: {
        title: {
            type: String,
            default: "Iniciar sessão",
        },
        description: {
            type: String,
            default: "Escolhe o método de autenticação para entrares nas plataformas internas.",
        },
        dividerText: {
            type: String,
            default: "Acesso seguro",
        },
        footerText: {
            type: String,
            default: "Ao continuar, estás a aceder ao ecossistema interno da Conduril.",
        },
    },
};
</script>
